@for (action of actions(); track action.id) {
  <sdc-button
    [variant]="action.variant"
    [class.gs-action-positive]="action.tone === 'positive'"
    [class.gs-action-negative]="action.tone === 'negative'"
    [attr.data-cy]="action.dataCy"
    (onClick)="actionClick.emit(action.id)">
    <span>{{ action.label }}</span>
    @if (action.indicator) {
      <span class="unread-indicator" aria-label="Unread errors"></span>
    }
  </sdc-button>
}
